<div [ngClass]="type!='product'?'all-in-one-table':'none'" class=" content-layout">
    <calsoft-page-header *ngIf="type!='product'" [height]="'180px'"
        background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
    </calsoft-page-header>
    <div class="container">

        <calsoft-breadcrumbs *ngIf="type!='product'" [url]="primaryTitle" [currentPage]="primaryTitle"
            [header]="'primary'"></calsoft-breadcrumbs>
        <div *ngIf="GridType !=  8">
            <calsoft-list [displayColumnRequired]="this.type != 'product'?'true':'false'"
                [searchRequired]="this.type != 'product'?true:false" [progress]="spinner"
                (filterChangeColumn)="onFilterChangeColumn($event)"
                [filterSelectObj]="this.type != 'product'?filterSelectObj:[]" name={{primaryTitle}} [columns]="columns"
                (filterChange)="onFilterChange($event)">
                <div class="actions" fxFlexAlign="center">

                    <button [attr.guide]="'add-attribute-btn-' + sanitizedUrl" [disabled]="!create" class="create"
                        (click)="addattribute()" matTooltip="Add Attribute" type="button" mat-mini-fab color="primary">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>

                <div *ngIf="read" [ngClass]="elements>5?'example-container':'none'" style="overflow-x:auto;">

                    <mat-table #table [dataSource]="attributeList" matSort (matSortChange)="sortData($event)"
                        style="user-select:none">

                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select" *ngIf="type=='product'">
                            <mat-header-cell *matHeaderCellDef>
                                <span>

                                </span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <!-- <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="changeValue($event.checked,row)"
                                [checked]="selection.isSelected(row.attributeId)"
                                [aria-label]="checkboxLabel(row.attributeId)">
                            </mat-checkbox> -->

                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="changeValue($event.checked,row)"
                                    [checked]="selectionAttribute.indexOf(row.attributeId) >= 0"
                                    [aria-label]="checkboxLabel(row.attributeId)">
                                </mat-checkbox>

                            </mat-cell>
                        </ng-container>


                        <!-- fullName Column -->
                        <ng-container *ngFor="let column of columns">
                            <ng-container *ngIf="column.isModelProperty" [matColumnDef]="column.property">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> {{ column.name }}</mat-header-cell>


                                <mat-cell *matCellDef="let row">
                                    <span *ngIf="type != 'product'">
                                        {{ row[column.property] }}
                                    </span>
                                    <span *ngIf="type == 'product'">
                                        {{ row['eavAttribute'][column.property] }}
                                    </span>
                                </mat-cell>

                            </ng-container>
                        </ng-container>
                        <!-- <ng-container matColumnDef="isRequired">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Required</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            {{row.isRequired == '1' ? "Yes" : "No"}}
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="isVisible">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Visible</mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <ng-container *ngIf="row.catalogEavAttribute==null"> null</ng-container>
                            <ng-container *ngIf="row.catalogEavAttribute!=null">
                                {{row.catalogEavAttribute['isVisible']== '1' ? "Yes" : "No"}}</ng-container>
                        </mat-cell>
                    </ng-container> -->
                        <ng-container matColumnDef="actions">
                            <mat-header-cell class="actions-cell" *matHeaderCellDef>ACTION</mat-header-cell>
                            <mat-cell class="actions-cell" *matCellDef="let row">
                                <button [attr.guide]="'actions-menu-btn-' + sanitizedUrl" type="button" mat-icon-button
                                    [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                                    <mat-icon>more_horiz</mat-icon>
                                </button>
                                <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                                    <button [attr.guide]="'edit-attribute-btn-' + sanitizedUrl"
                                        [disabled]="!resourcePrivilege?.update" (click)="editattribute(row.attributeId)"
                                        mat-menu-item>
                                        <mat-icon>edit</mat-icon>
                                        <span>edit</span>
                                    </button>
                                    <button [attr.guide]="'delete-attribute-btn-' + sanitizedUrl"
                                        [disabled]="!resourcePrivilege?.delete"
                                        (click)="deleteAllAttributeId(row.attributeId)" mat-menu-item>
                                        <mat-icon>delete</mat-icon>
                                        <span>delete</span>
                                    </button>

                                    <!-- <button (click)="deleteCustomer(row)" mat-menu-item>
                        <span>Delete</span>
                      </button>  -->
                                </mat-menu>
                            </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="visibleColumns; sticky: true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: visibleColumns;" class="clickable">
                        </mat-row>
                    </mat-table>
                </div>
                <div class="products-padding" fxLayoutAlign="center center" *ngIf="attributeList?.length === 0">No
                    records
                    found
                </div>
                <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
                    <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
                    <mat-paginator style="margin: 0px;" class="paginator" (page)="getUpdate($event)"
                        showFirstLastButtons [length]="pageList" [pageIndex]="page" [pageSize]="size"
                        [pageSizeOptions]="pageSizeValue"> </mat-paginator>
                </div>
            </calsoft-list>
        </div>
        <div *ngIf="GridType ==  8" class="custom-table gridtable-class"
            [class.filter-open-layout]="isFilterPanelOpen || isFilterPanelColumnOpen" fxLayout="row"
            [fxLayoutGap]="rowgap" style="width: 100%;">
            <div [fxFlex]="rowLeft" *ngIf="isGridVisible" fxLayout="column" style="width: 100%;">
                <div class="crm-container-new-eight">

                    <main class="main-content">

                        <section class="contacts-view">
                            <div class="contacts-header" fxLayoutAlign="space-between center">

                                <div fxFlex>
                                    <h2 class="sg-title">{{(currentRouterPath | moduleName) || primaryTitle}}</h2>
                                </div>

                                <div class="contact-actions">
                                    <button [attr.guide]="'refresh-btn-' + sanitizedUrl" class="btn btn-outline bhover"
                                        (click)="refresh()">
                                        <mat-icon>refresh</mat-icon>
                                        Refresh</button>

                                    <button [attr.guide]="'add-attribute-primary-btn-' + sanitizedUrl"
                                        class="btn btn-primary" (click)="addattribute()"><mat-icon>add</mat-icon>
                                        Add Attribute</button>
                                </div>
                            </div>

                            <div class="table-controls-wrapper">

                                <div class="table-controls">

                                    <div class="contacts-header">
                                        <div class="contact-actions">

                                            <button [attr.guide]="'view-menu-btn-' + sanitizedUrl" mat-button
                                                [matMenuTriggerFor]="viewMenu" class="btn-two btn-outline bhover">
                                                <mat-icon>layers</mat-icon>
                                            </button>

                                            <mat-menu #viewMenu="matMenu">
                                                <button [attr.guide]="'compact-view-btn-' + sanitizedUrl" mat-menu-item
                                                    (click)="setView('compact')">
                                                    <mat-icon>compress</mat-icon>
                                                    <span style="margin-left: 8px;">Compact</span>
                                                    <mat-icon *ngIf="viewMode === 'compact'"
                                                        style="margin-left:5px;">check</mat-icon>
                                                </button>
                                                <button [attr.guide]="'comfortable-view-btn-' + sanitizedUrl"
                                                    mat-menu-item (click)="setView('comfortable')">
                                                    <mat-icon>expand</mat-icon>
                                                    <span style="margin-left: 8px;">Comfortable</span>
                                                    <mat-icon *ngIf="viewMode === 'comfortable'"
                                                        style="margin-left:5px;">check</mat-icon>
                                                </button>
                                            </mat-menu>

                                            <button [attr.guide]="'toggle-filter-btn-' + sanitizedUrl"
                                                class="btn btn-outline bhover d-flex align-items-center gap-2"
                                                [class.active-filter]="filterActive" (click)="toggleFilterPanel()">
                                                <!-- Icon switches based on filterActive -->
                                                <mat-icon class="me-1">
                                                    {{ filterActive ? 'filter_alt' : 'filter_list' }}
                                                </mat-icon>

                                                <span>Filter</span>

                                                <!-- Nice little pill when applied -->
                                                <span *ngIf="filterActive" class="filter-pill">
                                                    <mat-icon class="pill-icon">check_circle</mat-icon>

                                                </span>
                                            </button>
                                            <button [attr.guide]="'toggle-filter-column-btn-' + sanitizedUrl"
                                                class="btn btn-outline bhover" (click)="toggleFilterColumnPanel()" [class.active-filter]="isFilterPanelColumnOpen">
                                                Filter by Columns
                                            </button>

                                        </div>
                                    </div>


                                </div>

                            </div>
                            <div class="leads-content-area" [class.filter-open]="isFilterPanelOpen"
                                [class.filter-column-open]="isFilterPanelColumnOpen">
                                <div class="table-wrapper">

                                    <table mat-table [dataSource]="attributeList" matSort
                                        (matSortChange)="sortData($event)" class="contacts-table" [ngClass]="viewMode">

                                        <ng-container *ngFor="let col of columns; trackBy: trackByProp"
                                            [sticky]="!isMobile && col.isSticky" [matColumnDef]="col.property">
                                            <ng-container *ngIf="col.isModelProperty!='false'">

                                                <ng-container
                                                    *ngIf="col.property !== 'actions' && col.property !== 'action' ">
                                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                        {{ col.name }}
                                                    </th>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="col.property === 'actions' || col.property === 'action'">
                                                    <th mat-header-cell *matHeaderCellDef class="actions-cell">
                                                        {{ col.name }}
                                                    </th>
                                                </ng-container>

                                                <td mat-cell *matCellDef="let element ;let i = index"
                                                    class="hover-cell">
                                                    <div class="cell-content-wrapper">
                                                        <div class="cell-data" style="padding-left: 15px;">

                                                            <ng-container [ngSwitch]="col.property">


                                                                <span *ngSwitchCase="'sourceName'">
                                                                    <ng-container *ngIf="editingCell?.rowId === element.sourceId 
                               && editingCell?.colProperty === col.property; else nameReadMode">

                                                                        <input
                                                                            [attr.guide]="'source-name-input-' + sanitizedUrl"
                                                                            *ngIf="col.inputType === 'text'" matInput
                                                                            [(ngModel)]="element.sourceName"
                                                                            placeholder="Enter sourceName" />

                                                                    </ng-container>

                                                                    <ng-template #nameReadMode>
                                                                        <div class="user-cell">
                                                                            <span class="name-cell">{{
                                                                                element.sourceName ||
                                                                                '(No
                                                                                Name)' }}</span>
                                                                        </div>
                                                                    </ng-template>
                                                                </span>

                                                                <span *ngSwitchCase="'actions'">
                                                                    <button
                                                                        [attr.guide]="'actions-menu-btn-row-' + sanitizedUrl"
                                                                        type="button" mat-icon-button
                                                                        [matMenuTriggerFor]="actionsMenu"
                                                                        (click)="$event.stopPropagation()">
                                                                        <mat-icon>more_horiz</mat-icon>
                                                                    </button>
                                                                    <mat-menu #actionsMenu="matMenu" yPosition="below"
                                                                        xPosition="before">


                                                                        <button
                                                                            [attr.guide]="'edit-attribute-btn-' + sanitizedUrl"
                                                                            [disabled]="!resourcePrivilege?.update"
                                                                            (click)="editattribute(element.attributeId   )"
                                                                            mat-menu-item>
                                                                            <mat-icon>edit</mat-icon>
                                                                            <span>edit</span>
                                                                        </button>

                                                                        <button
                                                                            [attr.guide]="'delete-attribute-btn-' + sanitizedUrl"
                                                                            [disabled]="!resourcePrivilege?.delete"
                                                                            (click)="deleteAllAttributeId(element.attributeId)"
                                                                            mat-menu-item>
                                                                            <mat-icon>delete</mat-icon>
                                                                            <span>delete</span>
                                                                        </button>

                                                                    </mat-menu>
                                                                </span>



                                                                <span *ngSwitchDefault>
                                                                    <ng-container *ngIf="editingCell?.rowId === element.sourceId 
                               && editingCell?.colProperty === col.property; else readMode">

                                                                        <input
                                                                            [attr.guide]="'value-input-' + sanitizedUrl"
                                                                            *ngIf="col.inputType === 'text'" matInput
                                                                            [(ngModel)]="element[col.property]"
                                                                            placeholder="Enter value" />

                                                                    </ng-container>
                                                                    <ng-template #readMode>
                                                                        <span>
                                                                            {{ element[col.property] || '--' }}
                                                                        </span>
                                                                    </ng-template>
                                                                </span>

                                                            </ng-container>
                                                        </div>

                                                        <!-- <div *ngIf="col.property != 'actions'" class="cell-actions">

                                                        <button mat-icon-button
                                                            *ngIf="!(editingCell?.rowId === element.sourceId && editingCell?.colProperty === col.property)"
                                                            aria-label="Edit value" class="icon-color icon-background">
                                                            <mat-icon
                                                                (click)="startEdit(element.sourceId, col.property, element, col); $event.stopPropagation()"
                                                                style="font-size: 17px;">edit</mat-icon>
                                                        </button>

                                                        <button mat-icon-button
                                                            *ngIf="editingCell?.rowId === element.sourceId && editingCell?.colProperty === col.property"
                                                            aria-label="Save value" class="icon-color icon-background">
                                                            <mat-icon
                                                                (click)="saveEdit(element.sourceId, col.property , element[col.property],element); $event.stopPropagation()"
                                                                style="font-size: 17px;">check</mat-icon>
                                                        </button>

                                                        <button mat-icon-button
                                                            *ngIf="editingCell?.rowId === element.sourceId && editingCell?.colProperty === col.property"
                                                            aria-label="Save value" class="icon-color icon-background">
                                                            <mat-icon
                                                                (click)="closeEdit(element.sourceId, col.property , element[col.property],element); $event.stopPropagation()"
                                                                style="font-size: 17px;">close</mat-icon>
                                                        </button>


                                                    </div> -->
                                                    </div>
                                                </td>


                                            </ng-container>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="visibleColumns;sticky:true"></tr>
                                        <tr mat-row *matRowDef="let row; columns: visibleColumns;">
                                        </tr>

                                    </table>
                                    <div style="padding: 20px;" fxLayoutAlign="center center"
                                        *ngIf="attributeList?.data?.length === 0 || attributeList?.length === 0">
                                        No records found
                                    </div>


                                    <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons
                                        [length]="pageList" [pageIndex]="page" [pageSize]="size"
                                        [pageSizeOptions]="pageSizeValue">
                                    </mat-paginator>

                                </div>

                                <div class="filter-panel" style="display: none;"></div>
                                <div class="filter-panel-column" style="display: none;"></div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>

            <!-- Modernized sliding filter panel -->
            <div class="side-form-container" *ngIf="isFilterPanelOpen" [fxFlex]="rowRight">
                <div class="side-form-card mat-elevation-z4" style="height: 100%;">
                    <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden; min-height: 0;">
                        <calsoft-filter-list-popup
                            style="display: flex; flex-direction: column; flex: 1; min-height: 0; height: 100%;" [type]="2" [columns]="columns"
                            [filterSelectObj]="filterSelectObj" (filterChangeColumn)="onFilterChangeColumn($event)"
                            [name]="primaryTitle" (closePopup)="closePopupNew($event)"></calsoft-filter-list-popup>
                    </div>
                </div>
            </div>

            <!-- Modernized sliding column visibility panel -->
            <div class="side-form-container" *ngIf="isFilterPanelColumnOpen" [fxFlex]="rowRight">
                <div class="side-form-card mat-elevation-z4" style="height: 100%;">
                    <div class="side-form-header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="title-area" fxLayout="row" fxLayoutAlign="space-between center">
                            <h3 style="margin: 0; margin-left: 5px;">Filter By Column</h3>
                        </div>
                        <button mat-icon-button (click)="toggleFilterColumnPanel()" aria-label="Close filter panel"
                            [attr.guide]="'common-attribute-btn-close-filter-column' + '__' + sanitizedUrl">
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    <div class="side-form-content">
                        <calsoft-column-visibility [columns]="columns" [filterType]="true"
                            (filterChangeColumn)="onFilterChangeColumn($event)"
                            (closePopup)="closePopupTwo($event)"></calsoft-column-visibility>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>